import { render, staticRenderFns } from "./edit-package.vue?vue&type=template&id=68c7e84c&scoped=true"
import script from "./edit-package.vue?vue&type=script&lang=tsx"
export * from "./edit-package.vue?vue&type=script&lang=tsx"
import style0 from "./edit-package.vue?vue&type=style&index=0&id=68c7e84c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c7e84c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68c7e84c')) {
      api.createRecord('68c7e84c', component.options)
    } else {
      api.reload('68c7e84c', component.options)
    }
    module.hot.accept("./edit-package.vue?vue&type=template&id=68c7e84c&scoped=true", function () {
      api.rerender('68c7e84c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ops/edit-package.vue"
export default component.exports